import React from "react";
import page1Queries from "./Page1Data";
import { Box } from "@mui/material";
import "./queriesExplaination.css";

const HomePageQueries = ({ setOpen }) => {
  return (
    <Box className="custom-modal-box">
      <Box className="queries-big-container ">
        <Box className="queries-container">
          <Box className="header">
            <h2 className="title">About</h2>
            <button className="close-button" onClick={() => setOpen(false)}>
              ✖
            </button>
          </Box>
          <Box className="queries-table-container">
            <table className="queries-table">
              <thead>
                <tr>
                  <th>Metric</th>
                  <th>Function</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {page1Queries.map((item, index) => (
                  <tr key={index}>
                    <td>{item.metric}</td>
                    <td>{item.function}</td>
                    <td>{item.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HomePageQueries;
